import { useEffect } from 'react';

type ModifierKey = 'ctrl' | 'alt' | 'shift' | null;

export function useKeyboardShortcut({
  key,
  callback,
  modifier = null,
  disabled = false,
}: {
  key: string;
  callback: () => void;
  modifier?: ModifierKey;
  disabled?: boolean;
}) {
  useEffect(() => {
    if (disabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      const isKeyMatched = event.key?.toLowerCase() === key.toLowerCase();
      const isModifierMatched =
        (modifier === 'ctrl' && event.ctrlKey) ||
        (modifier === 'alt' && event.altKey) ||
        (modifier === 'shift' && event.shiftKey) ||
        modifier === null;

      if (isKeyMatched && isModifierMatched) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [key, modifier, callback, disabled]);
}
